import { COMPANY_STATUES } from "../types";


const OnBoardingRoutes = [
  {
    label: COMPANY_STATUES.COMPANY_DETAILS,
    route: "welcome",
  },
  {
    label: COMPANY_STATUES.FACILITY_TYPES,
    route: "facility-setting",
  },
  {
    label: COMPANY_STATUES.FACILITY_INFORMATION,
    route: "facility-list",
  },
  {
    label: COMPANY_STATUES.EMISSION_SOURCE_SELECTION,
    route: "facility-emission-sources",
  },
  {
    label: COMPANY_STATUES.COMPLETE,
    route: "home",
  }
];

export const getOnBoardRoute = (label: COMPANY_STATUES): string => {

  const route = OnBoardingRoutes.find((item) => item.label === label);

  return route?.route || "home"
};